import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { confirm } from '../../../../core/components/Confirm';
import MenuGroupSetting from './MenuGroupSetting';
import { MembersIcon, ControlsContainer, SideWrapper, ControlItem, ControlItemLabel, ControlItemState, ControlItemArrowRight, } from './styles';
const ChatDetailsControls = ({ channelId, chatName, showMembers, leaveChat, memberCount }) => {
    const { formatMessage } = useIntl();
    const isDirectChat = memberCount <= 2;
    const handleLeaveChatClick = (e) => {
        e.stopPropagation();
        confirm({
            title: formatMessage({ id: 'chat.leaveChat.confirm.title' }),
            content: formatMessage({ id: 'chat.leaveChat.confirm.content' }),
            okText: formatMessage({ id: 'chat.leaveChat.confirm.okButton' }),
            onOk: () => leaveChat(),
        });
    };
    return (React.createElement(ControlsContainer, null,
        React.createElement(ControlItem, { onClick: showMembers },
            React.createElement(SideWrapper, null,
                React.createElement(MembersIcon, null),
                React.createElement(ControlItemLabel, null,
                    React.createElement(FormattedMessage, { id: "tabs.members" }))),
            React.createElement(SideWrapper, null,
                memberCount && React.createElement(ControlItemState, null, memberCount),
                React.createElement(ControlItemArrowRight, null))),
        !isDirectChat && React.createElement(MenuGroupSetting, { channelId: channelId, chatName: chatName }),
        React.createElement(ControlItem, { onClick: handleLeaveChatClick },
            React.createElement(ControlItemLabel, { isDanger: true },
                React.createElement(FormattedMessage, { id: "chat.leaveChat" })))));
};
export default ChatDetailsControls;
//# sourceMappingURL=index.js.map